import EditContributorModal from './EditContributorModal';

export default EditContributorModal;
